import React from "react";
import { hot } from "react-hot-loader";

import { RequestsInProgress } from "@api/components/RequestsInProgress";
import { Header } from "@app/components/layout/Header";
import { messages } from "@app/messages";
import { Routes } from "@app/routes";
import classNames from "classnames";
import { FormattedMessage } from "react-intl";

interface Props {
    authenticated: boolean;
}

const App = ({ authenticated }: Props) => (
    <div className={classNames("wrapper", { unauthenticated: !authenticated })}>
        <Header />

        <main>
            <Routes />

            <footer>
                <p className="text-center mt-3">
                    <FormattedMessage {...messages.copyright} />
                </p>
            </footer>
        </main>

        <RequestsInProgress />
    </div>
);

const HotApp = hot(module)(App);

export { HotApp as App };
